import { handleError } from 'config/libraries';
import React, { Fragment, useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import Slider from 'react-slick/lib/slider';

export const LinkTerkait = (params) => {

    const [DataResponse, setDataResponse] = useState([]);
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 7,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        // slidesToScroll: 1,
        // variableWidth: true
      };
    useEffect(() => {

        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/link-terkait').then(function (response) {
            setDataResponse(response.data.data);
        }).catch(function (error) {
          handleError(error)
      })
        return () => {
            setDataResponse(null);
        };
    }, []);

    return (
<section className="home_section2 mb-5">
            <div className="container">
            <div className="row">
                <div className="col-md-12">
                <div id="blockid_72be465" className="block-section jl-main-block" data-blockid="blockid_72be465" data-name="jl_mgrid" data-page_max={11} data-page_current={1} data-author="none" data-order="date_post" data-posts_per_page={6} data-offset={5}>
                    <div className="jl_grid_wrap_f jl_clear_at g_3col">
                    <div className="jl-roww content-inner jl-col3 jl-col-row">
                        <div className="jl_sec_title">
                        <h3 className="jl_title_c"><span>Link Terkait</span></h3>
                        <p>Link terkait Dinas Pendidikan</p>
                        </div>
                        
                    </div>
                    <Slider {...settings}>
                        {
                            DataResponse && DataResponse.map((item, index) => {
                                return (
                                    <a href={item.link} target="_blank" rel='noreferrer' key={index} className='container-link-terkait'>
                                        <img src={process.env.REACT_APP_SERVER_IMAGE_URL + item.logo_instansi} className="image-link-terkait" alt="" loading="lazy" />
                                        <p className='mt-4 mb-0'>{item.nama_instansi}</p>
                                    </a>
                                )
                            })
                        }
                        </Slider>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
    )
};